import React from 'react';
import { Star } from 'lucide-react';
import { Card } from './ui/card';
import { Avatar, AvatarFallback } from './ui/avatar';
import { useLanguage } from '../contexts/LanguageContext';

const Testimonials = () => {
  const { t } = useLanguage();
  const testimonials = t('testimonials.reviews');
  
  return (
    <section id="recensioni" className="py-20 bg-gradient-to-b from-gray-950 via-gray-900 to-gray-950 scroll-mt-20">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block">
            <span className="text-amber-400 font-semibold text-sm uppercase tracking-wider mb-2 block">
              {t('testimonials.badge')}
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t('testimonials.title')}
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto"></div>
          </div>
          <p className="text-gray-400 text-lg mt-6 max-w-2xl mx-auto">
            {t('testimonials.subtitle')}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={testimonial.id}
              className="group bg-gradient-to-br from-gray-900 to-gray-950 border-gray-800 hover:border-amber-500/50 p-6 transition-all duration-500 hover:shadow-2xl hover:shadow-amber-500/10 hover:-translate-y-2"
              style={{
                animationDelay: `${index * 100}ms`
              }}
            >
              {/* Rating Stars */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating || 5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-300 mb-6 leading-relaxed text-sm italic">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center space-x-3 pt-4 border-t border-gray-800">
                <Avatar className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600">
                  <AvatarFallback className="text-black font-bold">
                    {testimonial.name.split(' ').map(n => n[0]).join('')}
                  </AvatarFallback>
                </Avatar>
                <div>
                  <p className="text-white font-semibold text-sm">{testimonial.name}</p>
                  <p className="text-gray-500 text-xs">{testimonial.role}</p>
                  <p className="text-gray-600 text-xs mt-1">{testimonial.date}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-amber-500/10 to-amber-600/10 border border-amber-500/30 rounded-full px-6 py-3 backdrop-blur-sm">
            <Star className="w-6 h-6 text-amber-400 fill-amber-400" />
            <span className="text-white font-bold text-lg">5.0</span>
            <span className="text-gray-400">{t('testimonials.trustBadge')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
